<div appAccessProvider [accessCode]="{menuCode: 'SETTINGS', subMenuCode: 'ORDER_MANAGEMENT', pageCode: 'GENERAL', subPageCode: 'EDIT' }">
<div class="flex justify-content-end flex-wrap btn-with-links">
    <button pButton class="mr-2 bg-white default-text-light-black-color cursor-pointer border-button" [label]="'cancel' | translate" (click)="onCancel()"></button>
    <p-button  class="flex align-items-center justify-content-center cursor-pointer event-box" (click)="onNextBtnClick()" [label]="saveGeneralSettingsBtnLabel"></p-button>
</div>

<p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <div class="tab-icons">
              <i class="mi-lg details mr-2"></i>
              <span translate>settings.lbl_settings_general_management</span>
            </div>
        </ng-template>
        @for(tab of generalAttributeData?.tabs; track tab?.tabCode) {
            @if (showForm) {
              <app-mi-form
                    [attributeLabels]=" attributeLabels "
                    [moduleName]="exportGeneralSettingsModuleName"
                    [attributeValues]="attributeValues"
                    [groups]="tab.groups"
                    [isMultipleFilesUpload]="false"
                    [previousBtnText]="previousBtnLabel"
                    [submitBtnText]="saveExportSettingsBtnLabel"
                    (saveData)="saveGeneralSettings($event)"
                    [saveBtnId]="'general'"
                    [displaySubmitButtons]="true"
                    [submitBtnText]="saveGeneralSettingsBtnLabel"
                    (previousClick)="onCancel()"
                    [isTwoColStructure]="true"
                >   
                </app-mi-form>
            }

        }
         
</p-tabPanel>
</p-tabView>
</div>

